import React from 'react'
import { classNames } from '../../utils/dom'

const Card = ({ children, className }) => (
  <div className={classNames(['card', (className && className) || ''])}>
    {children}
  </div>
)

export default Card
